import React, { useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import client from '../../api/client';

export const downloadPdf = async (path, filename) => {
  const res = await client.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

export const ConsentProofButton = ({ path, filename, label = 'Download consent proof (PDF)', testId, toast }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await downloadPdf(path, filename); } catch (e) {
      toast?.({ title: 'Could not download', description: e.message, variant: 'destructive' });
    } finally { setBusy(false); }
  };
  return (
    <button data-testid={testId} onClick={go} disabled={busy}
      className="text-xs text-[#7B2C3B] hover:underline inline-flex items-center gap-1 disabled:opacity-50">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileText className="w-3 h-3" />} {label}
    </button>
  );
};

export default ConsentProofButton;
